import { Address4, Address6 } from "ip-address";
import { isValid } from "tldjs";
export const isValidURI = (uri) => isValid(uri);
export const isValidIP = (ip) => Address4.isValid(ip) || Address6.isValid(ip);
export const isValidQuery = (query) => {
    return isValidURI(query.toLowerCase()) || isValidIP(query.toLowerCase());
};
